import { useState } from 'react'
import { ArrowRight, Banknote } from 'lucide-react'
import ModalChangeInstallment from './ModalChangeInstallment'
import InstallmentsTax from '../../InstallmentsTax'
import { Logo } from '@/view/components/ui/logo'

interface InstallmentsProps {
  table: {
    success: boolean
    IDTabela: number
    CodigoTabela: string
    ValorLiquidoCliente: number
    Prazo?: number
  }
  cpf: string
  name: string
  onBack: () => void
  onRequestCredit: () => void
  onSimulateInstallment: (prazo?: number) => Promise<void>
}

const Installments = ({
  table,
  cpf,
  name,
  onBack,
  onRequestCredit,
  onSimulateInstallment,
}: InstallmentsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedPrazo, setSelectedPrazo] = useState<number | undefined>(
    undefined,
  )

  if (!table) return null

  async function handleSimulate() {
    try {
      await onSimulateInstallment(selectedPrazo)
      setIsModalOpen(false)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center">
      <div className="flex w-full max-w-xl items-center justify-center bg-white02 px-8 py-10">
        <div className="w-full">
          <div className="mb-6 rounded-lg border border-gray02 bg-white01 py-3 text-center text-lg font-semibold tracking-wide">
            {cpf} {name}
          </div>
          <div className="mb-8 flex flex-col items-center">
            <div className="h-20">
              <Logo className="h-full object-contain" />
            </div>
          </div>
          <InstallmentsTax
            currentTable={table}
            onAlterarClick={() => setIsModalOpen(true)}
          />
          <div className="mb-6">
            <button
              className="flex w-full items-center gap-3 rounded-xl border border-primary bg-primary/10 bg-white px-6 py-5"
              onClick={onRequestCredit}
            >
              <Banknote className="h-6 w-6 text-primary" />
              <div className="flex flex-1 flex-col items-start">
                <span className="text-xl font-semibold text-black01">
                  Iniciar saque
                </span>
                <p className="text-xs font-medium text-black04 opacity-80">
                  Liberação <span className="font-semibold">em até 24h</span>
                </p>
              </div>
              <ArrowRight className="ml-auto h-5 w-5 text-primary" />
            </button>
          </div>
          <button
            className="w-full rounded-xl bg-gray02 py-4 text-lg font-semibold text-black01 transition-colors hover:bg-gray02"
            onClick={onBack}
          >
            Voltar
          </button>
        </div>
        {isModalOpen && (
          <ModalChangeInstallment
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSimulate={handleSimulate}
            selectedPrazo={selectedPrazo}
            setSelectedPrazo={setSelectedPrazo}
            table={table}
          />
        )}
      </div>
    </div>
  )
}

export default Installments
